export default (props, vars) =>
  props?.['rotate'] && `rotate(${props?.['rotate']})`;
